import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import styles from './CreateUser.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import TextInput from '../../../Shared/TextInput/TextInput';
import DropdownInput from '../../../Shared/DropdownInput/DropdownInput';
import ListGroup from 'react-bootstrap/ListGroup';

function CreateUser(props: CreateUserProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();

    // Samme som på brukersida: hvilken seksjon som var åpen på /admin følger med
    // i history state, så tilbake-knappen her ikke lander på et kollapset /admin.
    const listUrl = "/admin" + ((location.state as any)?.listSearch ?? "");

    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const params = useParams();

    const [councils, setCouncils] = useState<Array<any>>([]);
    const [councilConnections, setCouncilConnections] = useState<Array<any>>([]);
    const [newcouncil, setNewCouncil] = useState<string>("");
    
    const [user, setUser] = useState<any | undefined>();

    const [email, setEmail] = useState<string>("");
    const [newUserCouncils, setNewUserCouncils] = useState<Array<any>>([]);
    const [password, setPassword] = useState<string>("");
    const [firstname, setFirstname] = useState<string>("");
    const [lastname, setLastname] = useState<string>("");

    function getUser() {
        axios.single({
            method: 'get',
            url: "/api/users/byid/" + params.userid + "/" + auth.selectedBreed,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setUser(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function createUser() {
        axios.single({
            method: 'put',
            url: "/api/users/createUser/",
            data:{
                email: email,
                password: password,
                firstname: firstname,
                lastname: lastname,
                councilConnections: newUserCouncils
            },
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setUser(res.data);
        }).catch((err: any) => {
            console.log(err);
        }).finally(() => {
            navigate(listUrl);
        });
    }

    function getCouncilConnections() {
        axios.single({
            method: 'get',
            url: "/api/users/getCouncilConnections/" + auth.user.userdata?.ID,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setCouncilConnections(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getCouncils() {
        axios.single({
            method: 'get',
            url: "/api/users/getCouncils",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setCouncils(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function ListOfCouncilConnections() {
        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                <ListGroup className={styles.listgroup}>
                    {t("user.edituser.councillist.title")}
                    {newUserCouncils?.map((council: any) => 
                        <ListGroup.Item className={styles.listgroupitem}>
                            {councils?.find(c => c.ID == council.COUNCIL_ID)?.NAME}
                            <DropdownInput
                                onChange={(event) => {
                                    newUserCouncils.find(i => i.COUNCIL_ID == council.COUNCIL_ID).ACCESSLEVEL = event.target.value;
                                    setNewUserCouncils([...newUserCouncils]);
                                }}
                                value={council.ACCESSLEVEL}
                            >
                                <option value="admin">{t("user.edituser.councillist.admin")}</option>
                                <option value="user">{t("user.edituser.councillist.user")}</option>
                                <option value="dogowner">{t("user.edituser.councillist.dogowner")}</option>
                            </DropdownInput>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setNewUserCouncils(newUserCouncils.filter(i => i.COUNCIL_ID !== council.COUNCIL_ID));
                                }}
                            >
                                {t("user.edituser.buttons.removecouncil")}
                            </button>
                        </ListGroup.Item>
                    )}
                </ListGroup>
            </div>
        );
    }

    useEffect(() => {
        if (params.userid != undefined) {
            getUser();
        }
    }, [params.userid]);

    useEffect(() => {
        getCouncilConnections();
        getCouncils();
    }, []);

    return (
        <div className="maincontent">
            <div className={styles.createuser}>
                <h1>{t("admin.createuser.title")}</h1>
                <hr />
                <button className="btn btn-primary" onClick={() => navigate(listUrl)}>{t("user.buttons.back")}</button>
                <hr/>
                <Container
                    className={styles.container}
                >
                    <Row className={styles.row}>
                        <Col
                            lg="6"
                            className={styles.col}
                        >
                            <TextInput
                                title={t("Epost")}
                                placeholder={t("epost")}
                                onChange={(event) => setEmail(event.target.value)}
                                value={email}
                            />
                            <TextInput
                                title={t("Fornavn")}
                                placeholder={t("Fornavn")}
                                onChange={(event) => setFirstname(event.target.value)}
                                value={firstname}
                            />
                            <TextInput
                                title={t("Etternavn")}
                                placeholder={t("Etternavn")}
                                onChange={(event) => setLastname(event.target.value)}
                                value={lastname}
                            />
                            {/* <DropdownInput
                                title={t("Rolle")}
                                onChange={(event) => setRole(event.target.value)}
                                value={role}
                            >
                                <option value="" disabled>{t("Rolle")}</option>
                                <option value="user">user</option>
                                <option value="sysadmin">sysadmin</option>
                            </DropdownInput> */}
                            <TextInput
                                title={t("Passord")}
                                placeholder={t("Passord")}
                                onChange={(event) => setPassword(event.target.value)}
                                value={password}
                            />

                            {ListOfCouncilConnections()}

                            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                                <DropdownInput
                                    style={{flexGrow: "1"}}
                                    onChange={(event) => setNewCouncil(event.target.value)}
                                    value={newcouncil}
                                >
                                    <option value="">{t("")}</option>
                                    {councils
                                        .filter(filt => !newUserCouncils.map(i => Number(i.COUNCIL_ID)).includes(filt.ID))
                                        .filter(council => auth.user?.userdata?.COUNCIL_ACCESS?.find((c: any) => c.COUNCIL_ID == council.ID || c.ACCESSLEVEL == "admin") != undefined)
                                        .map((council: any) => 
                                            <option value= {council.ID}> {council.NAME}</option>
                                        )
                                    }
                                </DropdownInput>
                                <button
                                    disabled={!newcouncil}
                                    style={{height: "fit-content", marginBottom: "13px"}}
                                    className="btn btn-primary"
                                    onClick={() => {
                                        setNewUserCouncils([...newUserCouncils, {
                                            COUNCIL_ID: newcouncil,
                                            ACCESSLEVEL: "user"
                                        }])
                                        setNewCouncil("");
                                    }}
                                >
                                    {t("user.edituser.buttons.addcouncil")}
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <hr />
            <button
                className="btn btn-primary"
                disabled={newUserCouncils.length == 0 || email == "" || password == ""}
                onClick={() => {
                    createUser();
                }}
            >{t("user.buttons.create")}</button>
            <hr/>
        </div>
    );
};

class CreateUserProps {
    
}

export default CreateUser;